import React, { useState, useEffect } from 'react';

function Countdown({ expirationTime }) {
  const [timeLeft, setTimeLeft] = useState(expirationTime - Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = expirationTime - Date.now();
      if (remainingTime <= 0) {
        setTimeLeft(0); // Stop the countdown at 0
        clearInterval(interval); // Clear the timer
      } else {
        setTimeLeft(remainingTime);
      }
    }, 1000); // Update every second

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [expirationTime]);

  // Convert milliseconds to minutes and seconds
  const minutes = Math.floor(timeLeft / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  return (
    <div>
      {timeLeft > 0 ? (
        <div>
          Link expires in: {minutes}m {seconds}s
        </div>
      ) : (
        <div>Link is expired</div>
      )}
    </div>
  );
}

export default Countdown;